import ApiGael from "@/services/apiGael.service";
import { FETCH_ALL } from "@/store/actions/actions.type";
import {
  FETCH_ALL_START,
  SET_ALL,
  FETCH_ALL_END
} from "@/store/mutations/mutations.type";

const state = {
  tags: {
    data: [],
    filters: []
  },
  isFetchingTags: false
};

const getters = {
  tags(state) {
    return state.tags;
  },
  isFetchingTags(state) {
    return state.isFetchingTags;
  }
};

const actions = {
  [FETCH_ALL](context, params) {
    return new Promise((resolve, reject) => {
      context.commit(FETCH_ALL_START);

      ApiGael.query("tags/list", params.payload)
        .then(response => {
          context.commit(SET_ALL, {
            tags: response.data,
            lazyLoad: params.lazyLoad
          });
          resolve();
        })
        .catch(e => {
          reject(e.response.data);
        })
        .finally(() => {
          context.commit(FETCH_ALL_END);
        });
    });
  }
};

const mutations = {
  [FETCH_ALL_START](state) {
    state.isFetchingTags = true;
  },
  [SET_ALL](state, payload) {
    if (payload.lazyLoad) {
      payload.tags.data = state.tags.data.concat(payload.tags.data);
    }

    state.tags = payload.tags;
  },
  [FETCH_ALL_END](state) {
    state.isFetchingTags = false;
  }
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
};
